import { adjustUrl } from '@d-shared/forms/forms';

export default {
  data: () => ({
    isLoading: false,
    isProcessing: false,
  }),

  methods: {
    blurUrlEntry(fieldName, shouldTouchField = false) {
      if (typeof this[fieldName] === 'undefined') {
        return false;
      }

      this[fieldName] = adjustUrl(this[fieldName]);

      if (shouldTouchField && this.$v) {
        this.$v[fieldName].$touch();
      }
      return true;
    },

    forceNumberInput(fieldName) {
      if (typeof this[fieldName] === 'undefined') {
        return false;
      }

      let fieldValue = this[fieldName].toString().replace(/\D/g, '');
      fieldValue = parseInt(fieldValue);

      if (isNaN(fieldValue)) {
        this[fieldName] = '';
        return false;
      }

      this[fieldName] = fieldValue;
      return true;
    },

    getValidationMessage($vField) {
      if (!$vField.$error) {
        return null;
      }

      if ($vField.$params.requiredIf && !$vField.requiredIf) {
        return 'Required';
      }
      if ($vField.$params.required && !$vField.required) {
        return 'Required';
      }
      if ($vField.$params.required && 'checked' in $vField.$params && !$vField.invalid) {
        return 'Required';
      }
      if ($vField.$params.email && !$vField.email) {
        return 'Invalid email';
      }
      if ($vField.$params.integer && !$vField.integer) {
        return 'Must be an integer';
      }
      if ($vField.$params.minLength && !$vField.minLength) {
        return `Minimum ${ $vField.$params.minLength.min } characters`;
      }
      if ($vField.$params.minValue && !$vField.minValue) {
        return `Minimum value is ${ $vField.$params.minValue.min }`;
      }
      if ($vField.$params.minWords && !$vField.minWords) {
        return `Minimum ${ $vField.$params.minWords.min } words`;
      }
      if ($vField.$params.maxLength && !$vField.maxLength) {
        return `Maximum ${ $vField.$params.maxLength.max } characters`;
      }
      if ($vField.$params.maxWords && !$vField.maxWords) {
        return `Maximum ${ $vField.$params.maxWords.max } words`;
      }
      if ($vField.$params.noSpaces && !$vField.noSpaces) {
        return 'No spaces allowed';
      }
      if ($vField.$params.instagramHandle && !$vField.instagramHandle) {
        return 'Invalid Instagram handle';
      }
      if ($vField.$params.twitterHandle && !$vField.twitterHandle) {
        return 'Invalid Twitter handle';
      }
      if ($vField.$params.url && !$vField.url) {
        return 'Invalid URL';
      }
      if ($vField.$params.repeat && !$vField.repeat) {
        return 'Does not match';
      }

      return 'Incorrect field';
    },

    touchField(fieldName) {
      if (typeof this.$v[fieldName] === 'undefined') {
        return false;
      }

      if (this.$v[fieldName].$params.integer) {
        this.forceNumberInput(fieldName);
      }

      this.$v[fieldName].$touch();
      return true;
    },
  },
};
